import * as React from "react"
import ChartType from "../../../enums/ChartType"
import { DatetimeSelector } from "../../Reusable/DatetimeSelector"
import GeoLocator from "../../Reusable/GeoLocator"
import { LocationSelector } from "../../Reusable/LocationSelector"
import { ResponseBlock } from "./ResponseBlock"
import { TestButton } from "./TestButton"

export function DevDocs() {
  return (
    <div className="d-flex flex-column ">
      <LocationSelector chartType={ChartType.DAILY}/>
      <GeoLocator />
      <DatetimeSelector />
      <TestButton/>
      <ResponseBlock/>
    </div>
  )
}
